import React, { useEffect } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import style from "./style";
import classNames from "classnames";
import { IconSuccess } from "../../../../Icons";
import _ from "lodash";


const useStyles = makeStyles(() => createStyles(style()));

type props = {
  onSnapchatResponse: any;
  appid: any;
  scope: any;
  AuthGroup: any
};

export const SnapChatAuth = (props: props): JSX.Element => {
  const classes = useStyles();


  const {onSnapchatResponse, appid, scope, AuthGroup } = props;
  const visibllity = (!_.isEmpty(AuthGroup.value) && !_.isNull(AuthGroup.value)) ? "visible" : "hidden";

   useEffect(() => {
    const channel = new BroadcastChannel("snapchat-auth-channel");
    channel.onmessage = (event) => {
      const AuthCode:any = event.data.code;
      onSnapchatResponse({ authCode: AuthCode });
    };
    return () => channel.close();
  }, []);

  const openNewTab = (): void => {
    const state = {
      targetCallback: `${window.origin}/snapchathandler`,
      toolParams: window.location.search
    };
    const redirectUri = `${process.env.REACT_APP_SOCIAL_CALLBACK}/snapchatredirect`; // must match Snap app settings exactly
    const width = 500;
    const height = 500;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;
    const features = `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`;
    const authUrl =
      `https://accounts.snapchat.com/login/oauth2/authorize?client_id=${encodeURIComponent(appid)}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&scope=${encodeURIComponent(scope)}&state=${encodeURIComponent(btoa(JSON.stringify(state)))}`;
    window.open(authUrl, "childwindow", features);
  }; 


  return (
    <div className={classes.snapchatContainer}>
      <div>
        <button type="button"
          className={classNames(classes.button, "MuiButtonBase-root")}
          disabled={!_.isEmpty(AuthGroup.value) && !_.isNull(AuthGroup.value)}
          onClick={openNewTab} 
        >
        
<div className={classes.buttonInner}>
  <svg className={classes.snapIcon} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                        <path d="M12 2c2.8 0 5 2.2 5 5v2.2c.3.2.8.3 1.3.3.4 0 .7.3.7.6 0 .5-.6.8-1.3 1 .4 1.2 1.4 2.5 2.8 3 .3.1.3.5.1.7-.5.4-1.3.6-1.9.7-.1.3-.2.6-.3.8-.2.3-.9.2-1.5.2-1 0-1.6.9-3.9.9s-2.9-.9-3.9-.9c-.6 0-1.3.1-1.5-.2-.1-.2-.2-.5-.3-.8-.6-.1-1.4-.3-1.9-.7-.2-.2-.2-.6.1-.7 1.4-.5 2.4-1.8 2.8-3-.7-.2-1.3-.5-1.3-1 0-.3.3-.6.7-.6.5 0 1-.1 1.3-.3V7c0-2.8 2.2-5 5-5z" />
                    </svg>

</div>

          <span className={classes.buttonLabelSnapchat}>Login with Snapchat</span>
        </button>


      </div>
      <div className={classes.successIconDiv} style={{ visibility: visibllity }}>
        <IconSuccess />
      </div>
    </div>

  );
};
